export interface CartAddItem {
  id: string | number;
  quantity: number;
  properties?: Record<string, any>;
}

/**
 * Generate a random 6-digit personalisation code
 */
export function generatePersonalisationCode(): string {
  return Math.floor(100000 + Math.random() * 900000).toString();
}

/**
 * Add items to Shopify cart with metadata
 */
export async function addToCart(items: CartAddItem[]): Promise<void> {
  const formData = new FormData();

  items.forEach((item, index) => {
    formData.append(`items[${index}][id]`, String(item.id));
    formData.append(`items[${index}][quantity]`, String(item.quantity));

    if (item.properties) {
      Object.entries(item.properties).forEach(([key, value]) => {
        formData.append(`items[${index}][properties][${key}]`, String(value));
      });
    }
  });

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || `Failed to add items to cart (${response.status})`
    );
  }

  // Trigger cart update event
  window.dispatchEvent(new Event('cart:updated'));
}

/**
 * Redirect to cart page
 */
export function redirectToCart(): void {
  window.location.href = '/cart';
}

